import React from 'react';
import RanksListing from '../modules/RanksListing/RanksListing';

const RanksPage = () =>{
  return <RanksListing/>
}

export default RanksPage;